import React from 'react';
import { Link } from 'react-router-dom';
import { useGeneralData } from "../../../data/GeneralDataContext";
import '../../../assets/css/footer.css';

const Footer = () => {
    const { evd_general_data, isLoading, error } = useGeneralData();

    if (isLoading) return <div className="small-footer"><div className="container">Loading...</div></div>;
    if (error) return <div className="small-footer"><div className="container">Error: {error}</div></div>;
    if (!evd_general_data || evd_general_data.length === 0) return <div className="small-footer"><div className="container">No General data available</div></div>;

    const generalData = evd_general_data[0];

    return (
        <footer className="small-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 mb-3 mb-md-0">
                        <div className="social-links">
                            {generalData.instagram_url && (
                                <a href={generalData.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <i className="bi bi-instagram"></i>
                                </a>
                            )}
                            {generalData.facebook_url && (
                                <a href={generalData.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <i className="bi bi-facebook"></i>
                                </a>
                            )}
                            {generalData.x_url && (
                                <a href={generalData.x_url} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                                    <i className="bi bi-twitter-x"></i>
                                </a>
                            )}
                        </div>
                        <p className="copyright mb-0">
                            © {new Date().getFullYear()} {generalData.evd_copyright || 'EVD Construction'}
                        </p>
                    </div>
                    <div className="col-lg-6 col-md-6 text-end">
                        <Link to="/terms" className="terms-link">
                            Terms & Conditions
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
